module.exports = __webpack_public_path__ + "static/img/memory6.1f43a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memory6.jpg
// module id = SMOF
// module chunks = 1